import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Row, 
  Col, 
  Card, 
  Button, 
  Badge, 
  Modal, 
  Carousel,
  Alert
} from 'react-bootstrap';
import { 
  Trophy, 
  Rocket, 
  Briefcase, 
  GraduationCap, 
  Award, 
  Users, 
  Target, 
  Zap,
  Clock,
  DollarSign,
  Star,
 CheckCircle,
  Calendar,
  Play,

} from 'lucide-react';

const BuildWinArena = () => {
  const [selectedChallenge, setSelectedChallenge] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const challenges = [
    {
      id: 'QC-2025-001',
      title: 'Quantum Financial Algorithm Optimizer',
      company: 'TechCorp Quantum Labs',
      prizePool: '₹1,50,000',
      vouchers: '₹25,000',
      duration: '6 weeks',
      technology: ['Quantum Computing', 'Python', 'Qiskit'],
      brief: 'Develop quantum algorithms for portfolio optimization in financial markets',
      internship: '3-month paid internship at TechCorp',
      bgClass: 'bg-primary',
      detailed: {
        overview: 'Develop cutting-edge quantum algorithms to solve complex financial portfolio optimization problems. This project will directly impact TechCorp\'s quantum computing division and contribute to their next-generation financial services platform.',
        requirements: [
          'Implement quantum algorithms using Qiskit framework',
          'Optimize portfolio allocation for maximum returns',
          'Handle risk assessment using quantum probability',
          'Create visualization dashboard for results',
          'Ensure scalability for large datasets',
          'Document algorithms for production deployment'
        ],
        prizes: [
          { place: '1st Place', amount: '₹90,000', voucher: '₹15,000', extra: 'Job Interview' },
          { place: '2nd Place', amount: '₹40,000', voucher: '₹7,000', extra: 'Internship Offer' },
          { place: '3rd Place', amount: '₹20,000', voucher: '₹3,000', extra: 'Certificate' },
          { place: 'Innovation Award', amount: '₹25,000', voucher: '', extra: 'Most Creative Approach' }
        ],
        timeline: [
          'Week 1-2: Research and algorithm design',
          'Week 3-4: Implementation and testing',
          'Week 5: Optimization and documentation',
          'Week 6: Final presentation and evaluation'
        ],
        internshipDetails: {
          duration: '3-month paid position',
          salary: '₹50,000/month',
          fullTime: '₹12+ LPA potential offer'
        }
      }
    },
    {
      id: 'AI-2025-002',
      title: 'Autonomous Supply Chain Management',
      company: 'LogiTech Solutions',
      prizePool: '₹1,00,000',
      vouchers: '₹15,000',
      duration: '5 weeks',
      technology: ['AI Agents', 'Machine Learning', 'Python'],
      brief: 'Create intelligent agents for end-to-end supply chain automation',
      internship: '6-month internship with potential full-time offer',
      bgClass: 'bg-success',
      detailed: {
        overview: 'Build sophisticated AI agents that can autonomously manage complex supply chain operations, from inventory management to delivery optimization.',
        requirements: [
          'Develop multi-agent systems for supply chain coordination',
          'Implement machine learning for demand forecasting',
          'Create real-time optimization algorithms',
          'Build dashboard for supply chain visualization',
          'Integrate with existing ERP systems',
          'Ensure scalability for enterprise deployment'
        ],
        prizes: [
          { place: '1st Place', amount: '₹60,000', voucher: '₹10,000', extra: 'Job Interview' },
          { place: '2nd Place', amount: '₹25,000', voucher: '₹5,000', extra: 'Internship Offer' },
          { place: '3rd Place', amount: '₹15,000', voucher: '', extra: 'Certificate' }
        ],
        timeline: [
          'Week 1: Agent architecture design',
          'Week 2-3: Core algorithm development',
          'Week 4: Integration and testing',
          'Week 5: Optimization and presentation'
        ],
        internshipDetails: {
          duration: '6-month internship',
          salary: '₹45,000/month',
          fullTime: '₹10+ LPA potential offer'
        }
      }
    },
    {
      id: 'BC-2025-003',
      title: 'Decentralized Identity Management System',
      company: 'SecureChain Inc.',
      prizePool: '₹75,000',
      vouchers: '₹20,000',
      duration: '4 weeks',
      technology: ['Blockchain', 'Smart Contracts', 'Web3'],
      brief: 'Build secure identity management for enterprise applications',
      internship: 'Immediate part-time opportunity during development',
      bgClass: 'bg-warning',
      detailed: {
        overview: 'Create a revolutionary blockchain-based identity management system that provides secure, decentralized authentication for enterprise applications.',
        requirements: [
          'Design smart contracts for identity verification',
          'Implement Web3 authentication protocols',
          'Build user-friendly interface for identity management',
          'Ensure GDPR compliance and privacy protection',
          'Create integration APIs for enterprise systems',
          'Develop comprehensive security audit framework'
        ],
        prizes: [
          { place: '1st Place', amount: '₹45,000', voucher: '₹12,000', extra: 'Job Interview' },
          { place: '2nd Place', amount: '₹20,000', voucher: '₹5,000', extra: 'Internship Offer' },
          { place: '3rd Place', amount: '₹10,000', voucher: '₹3,000', extra: 'Certificate' }
        ],
        timeline: [
          'Week 1: Smart contract architecture',
          'Week 2: Backend development',
          'Week 3: Frontend integration',
          'Week 4: Testing and deployment'
        ],
        internshipDetails: {
          duration: 'Part-time during development',
          salary: '₹30,000/month',
          fullTime: '₹8+ LPA potential offer'
        }
      }
    },
    {
      id: 'ST-2025-004',
      title: 'Satellite Data Processing Platform',
      company: 'AeroSpace Dynamics',
      prizePool: '₹2,00,000',
      vouchers: '₹30,000',
      duration: '8 weeks',
      technology: ['Space Tech', 'Data Processing', 'ML'],
      brief: 'Develop real-time satellite data analysis for weather prediction',
      internship: 'Exclusive space industry internship program',
      bgClass: 'bg-info',
      detailed: {
        overview: 'Build a cutting-edge platform for processing satellite data in real-time to provide accurate weather predictions and climate analysis.',
        requirements: [
          'Develop real-time data processing pipelines',
          'Implement machine learning for weather prediction',
          'Create visualization tools for satellite imagery',
          'Build APIs for third-party integrations',
          'Ensure high availability and scalability',
          'Develop mobile-responsive dashboard'
        ],
        prizes: [
          { place: '1st Place', amount: '₹1,20,000', voucher: '₹20,000', extra: 'Job Interview' },
          { place: '2nd Place', amount: '₹50,000', voucher: '₹8,000', extra: 'Internship Offer' },
          { place: '3rd Place', amount: '₹30,000', voucher: '₹2,000', extra: 'Certificate' }
        ],
        timeline: [
          'Week 1-2: Data pipeline architecture',
          'Week 3-4: ML model development',
          'Week 5-6: Platform integration',
          'Week 7-8: Testing and optimization'
        ],
        internshipDetails: {
          duration: '4-month exclusive program',
          salary: '₹60,000/month',
          fullTime: '₹15+ LPA potential offer'
        }
      }
    },
    {
      id: 'ES-2025-005',
      title: 'Smart Grid Optimization Engine',
      company: 'GreenTech Energy',
      prizePool: '₹1,25,000',
      vouchers: '₹20,000',
      duration: '6 weeks',
      technology: ['IoT', 'AI', 'Energy Systems'],
      brief: 'Create AI-powered systems for renewable energy distribution',
      internship: 'Clean energy sector career pathway',
      bgClass: 'bg-secondary',
      detailed: {
        overview: 'Develop an intelligent system that optimizes renewable energy distribution across smart grids, maximizing efficiency and sustainability.',
        requirements: [
          'Design IoT sensor integration framework',
          'Implement AI algorithms for energy optimization',
          'Create predictive models for energy demand',
          'Build control systems for grid management',
          'Develop monitoring and alerting systems',
          'Ensure integration with existing infrastructure'
        ],
        prizes: [
          { place: '1st Place', amount: '₹75,000', voucher: '₹12,000', extra: 'Job Interview' },
          { place: '2nd Place', amount: '₹35,000', voucher: '₹6,000', extra: 'Internship Offer' },
          { place: '3rd Place', amount: '₹15,000', voucher: '₹2,000', extra: 'Certificate' }
        ],
        timeline: [
          'Week 1-2: System architecture design',
          'Week 3-4: AI algorithm implementation',
          'Week 5: IoT integration and testing',
          'Week 6: Optimization and deployment'
        ],
        internshipDetails: {
          duration: '5-month clean energy program',
          salary: '₹50,000/month',
          fullTime: '₹12+ LPA potential offer'
        }
      }
    }
  ];

  const keyHighlights = [
    {
      icon: <Trophy size={48} />,
      title: 'Prize Money Rewards',
      description: 'Cash prizes from ₹10,000 to ₹2,00,000 per project',
      features: ['Amazon Gift Vouchers up to ₹50,000', 'Performance Bonuses ₹25,000', 'Referral Rewards 10% discount'],
      bgClass: 'bg-warning'
    },
    {
      icon: <Rocket size={48} />,
      title: 'Real Company Partnerships',
      description: 'Live projects from tech giants with direct mentorship',
      features: ['Industry Mentorship', 'Professional Exposure', 'Portfolio Building'],
      bgClass: 'bg-primary'
    },
    {
      icon: <Briefcase size={48} />,
      title: 'Career Opportunities',
      description: 'Direct hiring pipeline with guaranteed internships',
      features: ['90% Job Placement Rate', 'Skip Interview Processes', 'Industry Networks'],
      bgClass: 'bg-success'
    },
    {
      icon: <GraduationCap size={48} />,
      title: 'Exclusive Student Benefits',
      description: 'Premium access for enrolled students only',
      features: ['24/7 Support', 'Resource Library', 'Elite Community'],
      bgClass: 'bg-info'
    }
  ];

  const stats = [
    { number: '500+', label: 'Students Placed', icon: <Users size={32} /> },
    { number: '₹50+ Cr', label: 'Prize Money Distributed', icon: <DollarSign size={32} /> },
    { number: '95%', label: 'Satisfaction Rate', icon: <Star size={32} /> },
    { number: '50+', label: 'Company Partners', icon: <Target size={32} /> }
  ];

  const handleTakeChallenge = (challenge) => {
    setSelectedChallenge(challenge);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedChallenge(null);
  };

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % challenges.length);
  };

 

  // Auto-advance carousel
  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  },);

  return (
    <>
      <style jsx>{`
        .hero-section {
          background: linear-gradient(135deg, #1e293b 0%, #334155 50%, #1e293b 100%);
          color: white;
          position: relative;
          overflow: hidden;
        }
        .hero-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(90deg, rgba(59, 130, 246, 0.1), rgba(147, 51, 234, 0.1));
        }
        .hero-content {
          position: relative;
          z-index: 2;
        }
        .gradient-text {
          background: linear-gradient(90deg, #60a5fa, #a855f7);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .glassmorphism {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
        .challenge-card {
          transition: all 0.3s ease;
          height: 100%;
        }
        .challenge-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.2);
        }
        .stats-section {
          background: linear-gradient(90deg, #7c3aed, #2563eb);
        }
        .cta-section {
          background: linear-gradient(90deg, #ec4899, #ef4444);
        }
        .body-bg {
          background-color: #0f172a;
          min-height: 100vh;
        }
        .carousel-item {
          transition: transform 0.5s ease-in-out;
        }
        .carousel-indicators {
          bottom: -50px;
        }
        .carousel-control-prev,
        .carousel-control-next {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          width: 50px;
          height: 50px;
          top: 50%;
          transform: translateY(-50%);
        }
        .pulse {
          animation: pulse 2s infinite;
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
      `}</style>

      <div className="body-bg">
        {/* Hero Section */}
        <section className="hero-section py-5">
          <Container>
            <Row className="justify-content-center text-center hero-content">
              <Col lg={10}>
                <Alert variant="warning" className="d-inline-flex align-items-center mb-4 pulse">
                  <Zap size={20} className="me-2" />
                  BUILD & WIN ARENA
                </Alert>
                <h1 className="display-3 fw-bold mb-4">
                  Transform Real Company Projects Into Your{' '}
                  <span className="gradient-text">Career Launchpad</span>
                </h1>
                <p className="lead fs-4 text-light mb-4">
                  Step into the ultimate coding battlefield where your skills meet real-world challenges! 
                  Build industry-grade solutions, compete for substantial prize money, and land your dream job.
                </p>
                <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-3">
                  <Button variant="danger" size="lg" className="fw-bold px-4 py-3">
                    ENROLL NOW & ACCESS ALL CHALLENGES
                  </Button>
                  <div className="text-center">
                    <div className="fs-2 fw-bold text-warning">₹99,999</div>
                    <small className="text-muted">EMI: ₹8,333/month</small>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Key Highlights */}
        <section className="py-5">
          <Container>
            <Row className="justify-content-center text-center mb-5">
              <Col lg={8}>
                <h2 className="display-4 fw-bold gradient-text mb-4">
                  Why Choose Build & Win Arena?
                </h2>
              </Col>
            </Row>
            <Row className="g-4">
              {keyHighlights.map((highlight, index) => (
                <Col lg={3} md={6} key={index}>
                  <Card className="h-100 glassmorphism border-0 text-white">
                    <Card.Body className="p-4">
                      <div className={`d-inline-flex p-3 rounded-circle ${highlight.bgClass} mb-3`}>
                        {highlight.icon}
                      </div>
                      <Card.Title className="h5 mb-3">{highlight.title}</Card.Title>
                      <Card.Text className="text-light mb-3">{highlight.description}</Card.Text>
                      <ul className="list-unstyled">
                        {highlight.features.map((feature, idx) => (
                          <li key={idx} className="d-flex align-items-start mb-2">
                            <CheckCircle size={16} className="text-success me-2 mt-1 flex-shrink-0" />
                            <small className="text-light">{feature}</small>
                          </li>
                        ))}
                      </ul>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* Challenge Cards Carousel */}
        <section className="py-5">
          <Container>
            <Row className="justify-content-center text-center mb-5">
              <Col lg={8}>
                <h2 className="display-4 fw-bold gradient-text mb-4">
                  Live Company Challenges
                </h2>
                <p className="fs-5 text-light">Real projects, real companies, real opportunities</p>
              </Col>
            </Row>
            
            <Row className="justify-content-center">
              <Col lg={10}>
                <Carousel 
                  activeIndex={activeIndex} 
                  onSelect={setActiveIndex}
                  interval={5000}
                  className="challenge-carousel"
                >
                  {challenges.map((challenge, index) => (
                    <Carousel.Item key={challenge.id}>
                      <Card className={`${challenge.bgClass} border-0 text-white challenge-card`}>
                        <Card.Body className="p-5">
                          <div className="d-flex justify-content-between align-items-start mb-4">
                            <div>
                              <Badge bg="light" text="dark" className="mb-2">
                                {challenge.company}
                              </Badge>
                              <Card.Title className="display-6 fw-bold">{challenge.title}</Card.Title>
                            </div>
                            <Badge bg="dark" className="d-flex align-items-center">
                              <Clock size={16} className="me-1" />
                              {challenge.duration}
                            </Badge>
                          </div>
                          
                          <Card.Text className="fs-5 mb-4">{challenge.brief}</Card.Text>
                          
                          <Row className="g-3 mb-4">
                            <Col md={6}>
                              <Card bg="dark" className="bg-opacity-25">
                                <Card.Body className="p-3">
                                  <div className="d-flex align-items-center mb-2">
                                    <DollarSign size={20} className="text-warning me-2" />
                                    <span className="fw-semibold">Prize Pool</span>
                                  </div>
                                  <div className="display-6 fw-bold text-warning">{challenge.prizePool}</div>
                                  <small className="text-light">+ {challenge.vouchers} vouchers</small>
                                </Card.Body>
                              </Card>
                            </Col>
                            <Col md={6}>
                              <Card bg="dark" className="bg-opacity-25">
                                <Card.Body className="p-3">
                                  <div className="d-flex align-items-center mb-2">
                                    <Briefcase size={20} className="text-success me-2" />
                                    <span className="fw-semibold">Opportunity</span>
                                  </div>
                                  <small className="text-light">{challenge.internship}</small>
                                </Card.Body>
                              </Card>
                            </Col>
                          </Row>

                          <div className="mb-4">
                            {challenge.technology.map((tech, idx) => (
                              <Badge key={idx} bg="light" text="dark" className="me-2 mb-2">
                                {tech}
                              </Badge>
                            ))}
                          </div>

                          <Button 
                            variant="light" 
                            size="lg" 
                            className="w-100 fw-bold d-flex align-items-center justify-content-center"
                            onClick={() => handleTakeChallenge(challenge)}
                          >
                            <Play size={20} className="me-2" />
                            Take Challenge
                          </Button>
                        </Card.Body>
                      </Card>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Stats Section */}
        <section className="stats-section py-5">
          <Container>
            <Row className="g-4">
              {stats.map((stat, index) => (
                <Col lg={3} md={6} key={index} className="text-center text-white">
                  <div className="mb-3">
                    <div className="d-inline-flex p-3 rounded-circle bg-white bg-opacity-25">
                      {stat.icon}
                    </div>
                  </div>
                  <div className="display-4 fw-bold mb-2">{stat.number}</div>
                  <div className="text-white-50">{stat.label}</div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* CTA Section */}
        <section className="cta-section py-5">
          <Container>
            <Row className="justify-content-center text-center">
              <Col lg={10}>
                <h2 className="display-4 fw-bold text-white mb-4">
                  Start Your Journey From Student to Industry Professional
                </h2>
                <p className="fs-5 text-white mb-4">
                  Join 500+ students who have already transformed their careers through our arena
                </p>
                <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-3 mb-4">
                  <Button variant="light" size="lg" className="fw-bold px-4 py-3">
                    ENROLL NOW & ACCESS ALL CHALLENGES
                  </Button>
                  <div className="text-center">
                    <div className="display-5 fw-bold text-white">₹99,999</div>
                    <small className="text-white-50">EMI: ₹8,333/month</small>
                  </div>
                </div>
                <Row className="g-3 text-sm">
                  <Col md={4}>
                    <div className="d-flex align-items-center justify-content-center text-white">
                      <CheckCircle size={16} className="me-2" />
                      25% discount for first 50 students
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="d-flex align-items-center justify-content-center text-white">
                      <CheckCircle size={16} className="me-2" />
                      90% job placement guarantee
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="d-flex align-items-center justify-content-center text-white">
                      <CheckCircle size={16} className="me-2" />
                      10% referral cashback
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Challenge Detail Modal */}
        <Modal 
          show={showModal} 
          onHide={handleCloseModal} 
          size="xl" 
          scrollable
          className="challenge-modal"
        >
          {selectedChallenge && (
            <>
              <Modal.Header closeButton className="bg-dark text-white">
                <Modal.Title className="fs-4">{selectedChallenge.title}</Modal.Title>
              </Modal.Header>
              
              <Modal.Body className="bg-dark text-white">
                <div className="space-y-4">
                  {/* Overview */}
                  <div className="mb-4">
                    <h5 className="text-primary mb-3">Project Overview</h5>
                    <p className="text-light">{selectedChallenge.detailed.overview}</p>
                  </div>

                  {/* Requirements */}
                  <div className="mb-4">
                    <h5 className="text-success mb-3">Requirements</h5>
                    <ul className="list-unstyled">
                      {selectedChallenge.detailed.requirements.map((req, index) => (
                        <li key={index} className="d-flex align-items-start mb-2">
                          <CheckCircle size={20} className="text-success me-3 mt-1 flex-shrink-0" />
                          <span className="text-light">{req}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Prize Structure */}
                  <div className="mb-4">
                    <h5 className="text-warning mb-3">Prize Structure</h5>
                    <Row className="g-3">
                      {selectedChallenge.detailed.prizes.map((prize, index) => (
                        <Col md={6} key={index}>
                          <Card bg="secondary" className="h-100">
                            <Card.Body>
                              <div className="d-flex align-items-center mb-2">
                                <Award size={20} className="text-warning me-2" />
                                <span className="fw-semibold text-white">{prize.place}</span>
                              </div>
                              <div className="display-6 fw-bold text-warning">{prize.amount}</div>
                              {prize.voucher && <div className="text-light">{prize.voucher} vouchers</div>}
                              <Badge bg="success" className="mt-2">
                                {prize.extra}
                              </Badge>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </div>

                  {/* Timeline */}
                  <div className="mb-4">
                    <h5 className="text-info mb-3">Timeline</h5>
                    <ul className="list-unstyled">
                      {selectedChallenge.detailed.timeline.map((phase, index) => (
                        <li key={index} className="d-flex align-items-start mb-2">
                          <Calendar size={20} className="text-info me-3 mt-1 flex-shrink-0" />
                          <span className="text-light">{phase}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Internship Details */}
                  <div className="mb-4">
                    <h5 className="text-warning mb-3">Career Opportunities</h5>
                    <Alert variant="warning" className="bg-warning bg-opacity-25 border-warning">
                      <Row>
                        <Col md={4}>
                          <div className="fw-semibold mb-1 text-white">Duration:</div>
                          <div className="text-white">{selectedChallenge.detailed.internshipDetails.duration}</div>
                        </Col>
                        <Col md={4}>
                          <div className="fw-semibold mb-1 text-white">Monthly Salary:</div>
                          <div className="text-white">{selectedChallenge.detailed.internshipDetails.salary}</div>
                        </Col>
                        <Col md={4}>
                          <div className="fw-semibold mb-1 text-white">Full-time Potential:</div>
                          <div className="text-white">{selectedChallenge.detailed.internshipDetails.fullTime}</div>
                        </Col>
                      </Row>
                    </Alert>
                  </div>
                </div>
              </Modal.Body>
              
              <Modal.Footer className="bg-dark">
                <Button variant="success" size="lg" className="flex-fill fw-bold">
                  <GraduationCap size={20} className="me-2" />
                  Enroll in Program & Accept Challenge
                </Button>
                <Button variant="secondary" onClick={handleCloseModal}>
                  Close
                </Button>
              </Modal.Footer>
            </>
          )}
        </Modal>
      </div>
    </>
  );
};

export default BuildWinArena;